import { render, staticRenderFns } from "./pagedTable.vue?vue&type=template&id=044d9fa2&"
import script from "./pagedTable.vue?vue&type=script&lang=ts&"
export * from "./pagedTable.vue?vue&type=script&lang=ts&"
import style0 from "./pagedTable.vue?vue&type=style&index=0&id=044d9fa2&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports